import React from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'
import { OperationsDept } from '../../components/operationdept'
import { OperationsData } from '../../operationsdata'

const Operations = () => {
  return (
    <Container>
        <NavBar />
        <InnerContainer>
            <h2>Nigeriana Publications</h2>
            <p>Below are Nigerian publications made in Nigeria </p>

            <OperationsCard>

                {
                    OperationsData.map((operation) => {
                        return(
                            <OperationsDept key={operation.id}
                            department={operation.department}
                            desc={operation.desc}
                            list1={operation.list1}
                            list2={operation.list2}
                            list3={operation.list3}
                            list4={operation.list4}
                            link={operation.link}
                            operation={operation} />
                        )
                    })
                }

            
            </OperationsCard>

        </InnerContainer>
        <Footer />
    </Container>
  )
}

const Container =  styled.section`
    width: 100%;
    max-width: 1250%;
    margin: 0 auto;  // center the page

    

`
const InnerContainer = styled.div`
    width: 80%;
    max-width: 1250%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    
    & > h2{
        margin-top: 45px;
    }

    & > p{

    }
`
const OperationsCard = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
`

export {Operations}